/**
 * Format a number the way a South African learner reads it: decimal comma,
 * thousands separated by a space (`12 345,68`), no trailing zeros.
 *
 * `en-ZA` in Intl gives exactly this. `maxFractionDigits` caps the decimals;
 * integers print without any.
 */
export function saNumber(n: number, maxFractionDigits = 2): string {
  if (!isFinite(n)) return "";
  return new Intl.NumberFormat("en-ZA", {
    maximumFractionDigits: maxFractionDigits,
    useGrouping: true,
  }).format(n);
}
